"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var AppLayoutWrapper = /** @class */ (function (_super) {
    __extends(AppLayoutWrapper, _super);
    function AppLayoutWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppLayoutWrapper.prototype.findNavigation = function () {
        return this.find('.awsui-app-layout__navigation');
    };
    AppLayoutWrapper.prototype.findNavigationLandmark = function () {
        return this.find('.awsui-app-layout__navigation-landmark');
    };
    AppLayoutWrapper.prototype.findNavigationToggle = function () {
        return this.find('.awsui-app-layout__toggle--navigation');
    };
    AppLayoutWrapper.prototype.findMobileNavigationToggle = function () {
        return this.find('.awsui-app-layout__toggle--navigation-mobile');
    };
    AppLayoutWrapper.prototype.findNavigationClose = function () {
        return this.find('.awsui-app-layout__navigation .awsui-app-layout__close-button button');
    };
    AppLayoutWrapper.prototype.findContentRegion = function () {
        return this.find('.awsui-app-layout__content');
    };
    AppLayoutWrapper.prototype.findNotifications = function () {
        return this.find('.awsui-app-layout__notifications');
    };
    AppLayoutWrapper.prototype.findBreadcrumbs = function () {
        return this.find('.awsui-app-layout__breadcrumbs');
    };
    AppLayoutWrapper.prototype.findTools = function () {
        return this.find('.awsui-app-layout__tools');
    };
    AppLayoutWrapper.prototype.findToolsClose = function () {
        return this.findTools().find('.awsui-app-layout__close-button button');
    };
    AppLayoutWrapper.prototype.findToolsToggle = function () {
        return this.find('.awsui-app-layout__toggle--tools');
    };
    AppLayoutWrapper.prototype.findToolsLandmark = function () {
        return this.find('.awsui-app-layout__tools-landmark');
    };
    AppLayoutWrapper.prototype.findMobileToolsToggle = function () {
        return this.find('.awsui-app-layout__toggle--tools-mobile');
    };
    return AppLayoutWrapper;
}(dom_1.ComponentWrapper));
exports.default = AppLayoutWrapper;
//# sourceMappingURL=awsui-app-layout.js.map